import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Zap, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const CTASection = () => {
  const { t } = useLanguage();
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6">
            {t("พร้อมที่จะ", "Ready to")} <span className="text-gradient">{t("สร้างสรรค์", "Create")}</span>?
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            {t("ร่วมกับผู้สร้างหลายพันคนที่ใช้ AI ในการทำให้วิสัยทัศน์ของพวกเขาเป็นจริง เริ่มต้นด้วยเครดิตฟรีวันนี้", "Join thousands of creators using AI to bring their visions to life. Start with free credits today.")}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/register">
              <Button variant="hero" size="xl" className="gap-2">
                <Zap className="h-5 w-5" />
                {t("เริ่มต้นฟรี", "Get Started Free")}
              </Button>
            </Link>
            <Link to="/pricing">
              <Button variant="glass" size="xl" className="gap-2">
                {t("ดูราคา", "View Pricing")}
                <ArrowRight className="h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
